import React from 'react'
import NFLScoreboardGame from './NFLScoreboardGame'
import * as s from './NFLScoreboard.scss'
import moment from 'moment-timezone'
import pluralize from 'pluralize'

const NFLScoreboardGameDay = ({ gameDay = {}, seasonId, seasonName, seasonMode, week, showLines = true }) => {

    const d = gameDay
    if (!d || !d.gameCount) return null
    return (
        <div className={s.dayContainer}>
            <div className={s.dayHeader}>
                <h3>{moment(d.gameDate).format('dddd, MMMM Do')}</h3>
                <span>{pluralize('game', d.gameCount, true)}</span>
            </div>
            <div className={s.dayGrid}>
            {d.games && d.games.map((g, gameIndex) =>
                <NFLScoreboardGame game={g} seasonId={seasonId} seasonName={seasonName}
                    seasonMode={seasonMode} week={week} showLine={showLines}
                    key={`nfl-scoreboard-${seasonId}-${seasonMode}-${week}-${d.gameDate}-${gameIndex}`} />
            )}
            </div>
        </div>
    )
}

export default NFLScoreboardGameDay
